<template>
  <div class="customer-edit-invoices">
    <customer-show-quotation ref="showquotation" :customer="customer" :clinic="clinic"
      @submit="onSubmit"></customer-show-quotation>
    <customer-show-payment ref="showpayment" :customer="customer" :pending="pending"
      @submit="onSubmit"></customer-show-payment>
    <customer-show-payment-mult ref="showpaymentmult" :pending="pending" :customer="customer"
      @submit="onSubmit"></customer-show-payment-mult>
    <customer-show-invoice ref="showinvoice" :customer="customer" :clinic="clinic"
      @submit="onSubmit"></customer-show-invoice>
    <customer-gen-quotation-payments ref="genpayments" :customer="customer" :clinic="clinic" @submit="onSubmit">
    </customer-gen-quotation-payments>


    <div class="customer-edit-invoices__topbar mt-4">
      <div class="row">
        <div class="col-md-7">
          <div class="customer-edit-invoices__boxed d-flex align-items-center justify-content-between">
            <div class="customer-edit-invoices__balance">
              <div v-if="enable_payments_v2" class="customer-edit-invoices__balance-new">
                <div>
                  <strong v-if="show_treatment_pending" data-trigger="tooltip"
                    title="Pendiente = Valor Trat. Realizados - Valor Trat. Pagados">
                    PENDIENTE DE PAGO: {{ pretty_treatment_pending }}
                  </strong>

                  <strong data-trigger="tooltip" title="Saldo = Depositado - Asignado">
                    SALDO: {{ pretty_pending }}
                  </strong>
                </div>
              </div>
              <div v-else>
                <strong>{{ pretty_pending }}</strong>
                SALDO
                <sup v-if="is_core">
                  <i class="fas fa-question-circle" data-trigger="tooltip" :title="tooltip_title"></i>
                </sup>
              </div>

              <button type="button" v-if="balance_mismatch" @click="showMismatch"
                class="btn btn-primary btn-wabident-round small mx-2">
                <i class="fas fa-exclamation-triangle"></i> Discrepancia
                detectada
              </button>
            </div>

            <div>
              <a v-if="enable_payments_v2" @click="addDeposit" role="button" target="_blank"
                class="btn btn-primary btn-wabident-round">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M10.4508 5.05079L6.94922 5.05079L6.94922 1.54923C6.94922 1.29748 6.84921 1.05604 6.6712 0.878026C6.49319 0.700013 6.25175 0.600007 6 0.600007C5.74825 0.600007 5.50681 0.700013 5.3288 0.878026C5.15079 1.05604 5.05078 1.29748 5.05078 1.54923L5.05078 5.05079L1.54922 5.05079C1.29747 5.05079 1.05603 5.15079 0.878018 5.32881C0.700005 5.50682 0.599998 5.74826 0.599998 6.00001C0.599998 6.25175 0.700005 6.49319 0.878018 6.6712C1.05603 6.84922 1.29747 6.94922 1.54922 6.94922L5.05078 6.94922L5.05078 10.4508C5.05078 10.7025 5.15079 10.944 5.3288 11.122C5.50681 11.3 5.74825 11.4 6 11.4C6.25175 11.4 6.49318 11.3 6.6712 11.122C6.84921 10.944 6.94922 10.7025 6.94922 10.4508L6.94922 6.94923L10.4508 6.94923C10.7025 6.94923 10.944 6.84922 11.122 6.67121C11.3 6.49319 11.4 6.25176 11.4 6.00001C11.4 5.74826 11.3 5.50682 11.122 5.32881C10.944 5.15079 10.7025 5.05079 10.4508 5.05079Z"
                    fill="white" />
                </svg>
                Añadir Saldo
              </a>

              <a role="button" target="_blank" :href="customer_payment_report_link"
                class="btn btn-primary btn-wabident-round mx-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <g clip-path="url(#clip0_279_1651)">
                    <path
                      d="M10.05 4.65001L10.05 2.2295C10.05 2.05041 9.97892 1.87892 9.85236 1.75215L8.89766 0.797655C8.77109 0.671093 8.59939 0.600007 8.4203 0.600007L2.62501 0.600006C2.25228 0.600006 1.95001 0.90228 1.95001 1.27501L1.95001 4.65001C1.20434 4.65001 0.600006 5.25434 0.600006 6.00001L0.600005 8.36251C0.600005 8.54897 0.751037 8.70001 0.937505 8.70001L1.95001 8.70001L1.95001 10.725C1.95001 11.0977 2.25228 11.4 2.62501 11.4L9.37501 11.4C9.74773 11.4 10.05 11.0977 10.05 10.725L10.05 8.70001L11.0625 8.70001C11.249 8.70001 11.4 8.54898 11.4 8.36251L11.4 6.00001C11.4 5.25434 10.7957 4.65001 10.05 4.65001ZM8.70001 10.05L3.30001 10.05L3.30001 8.02501L8.70001 8.02501L8.70001 10.05ZM8.70001 5.32501L3.30001 5.32501L3.30001 1.95001L7.35001 1.95001L7.35001 2.96251C7.35001 3.14898 7.50104 3.30001 7.68751 3.30001L8.70001 3.30001L8.70001 5.32501ZM9.71251 6.84376C9.43301 6.84376 9.20626 6.617 9.20626 6.33751C9.20626 6.0578 9.43301 5.83126 9.71251 5.83126C9.992 5.83126 10.2188 6.0578 10.2188 6.33751C10.2188 6.617 9.992 6.84376 9.71251 6.84376Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_279_1651">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                Informe
              </a>
            </div>
          </div>
        </div>

        <div class="col-md-5">
          <div class="customer-edit-invoices__boxed customer-edit-invoices__summary">
            <div class="customer-edit-invoices__summary-item">
              <span v-if="enable_payments_v2"> Planificado: </span>
              <span v-else> Presupuestado: </span>
              <span class="customer-edit-invoices__summary-amount">
                {{ pretty_quoted }}
              </span>
            </div>

            <div class="customer-edit-invoices__summary-item">
              Realizado:
              <span class="customer-edit-invoices__summary-amount">
                {{ pretty_done }}
              </span>
            </div>

            <div class="customer-edit-invoices__summary-item">
              Marcado pagado:
              <span class="customer-edit-invoices__summary-amount">
                {{ pretty_paid }}
              </span>
            </div>

            <div v-if="enable_payments_v2" class="customer-edit-invoices__summary-item">
              Depositado:
              <span class="customer-edit-invoices__summary-amount">
                {{ pretty_deposited }}
              </span>
            </div>

            <div v-if="enable_payments_v2" class="customer-edit-invoices__summary-item">
              Asignado:
              <span class="customer-edit-invoices__summary-amount">
                {{ pretty_assigned }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row customer-edit-invoices__tabs">
      <div class="col-md-4 customer-edit-invoices__tab" :class="{ active: tab == 'pending' }" @click="tab = 'pending'">
        <span v-if="enable_payments_v2"> Planes Pendientes </span>
        <span v-else> Tratamientos pendientes </span>
      </div>
      <div class="col-md-4 customer-edit-invoices__tab" :class="{ active: tab == 'payments' }"
        @click="tab = 'payments'">
        <span v-if="enable_payments_v2"> Transacciones </span>
        <span v-else> Cobros </span>
      </div>
      <div v-if="can_invoice" class="col-md-4 customer-edit-invoices__tab" :class="{ active: tab == 'invoices' }"
        @click="tab = 'invoices'">
        Facturas
      </div>
    </div>

    <!-- TREATMENTS / QUOTATIONS TAB-->
    <div v-if="tab == 'pending'" class="row treatments my-2">
      <div class="col">
        <transition name="fade">
          <button v-if="has_pending_treatments && !enable_payments_v2" type="button"
            class="btn btn-primary btn-wabident-round float-right" @click="payAllTreatments(false)">
            PAGAR SELECIONADOS
          </button>
        </transition>

        <div class="quotation-list">
          <div v-if="!pending_quotations.length" class="quotation-list-empty">
            <span v-if="hide_paid_treatments">
              No hay tratamientos pendientes de pagar
            </span>
            <span v=else>
              No hay tratamientos pendientes de pagar ni realizar
            </span>
          </div>

          <div class="quotation-list__item" :class="{ expanded: expanded_quotations[quotation.id] }" :key="i"
            v-for="(quotation, i) in pending_quotations">
            <div class="quotation-list__title d-flex align-items-center">
              <span data-bs-toggle="tooltip" title="Pulsa aquí para mostrar los Tratamientos pendientes"
                @click="toggleQuotation(quotation.id)">
                <svg class="quotation-list__icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                  viewBox="0 0 15 15" fill="none">
                  <path
                    d="M1.65836 3.60001H13.3416C14.1499 3.60001 14.554 4.57626 13.9819 5.14839L8.14251 10.9923C7.78834 11.3465 7.21166 11.3465 6.85749 10.9923L1.01812 5.14839C0.44599 4.57626 0.850114 3.60001 1.65836 3.60001Z"
                    fill="#A6AAB4" />
                </svg>
              </span>

              <div class="d-flex align-items-center justify-content-between w-100">
                <div @click="toggleQuotation(quotation.id)">
                  <b>Plan:</b> {{ quotation.name }} - <b>Fecha:</b> {{ quotation.created_at }} - <b>Total:</b> {{
                    quotation.net_price }}
                </div>
                <div>
                  <button v-if="enable_sepa_transfers" class="btn btn-wabident-round greeen" type="button"
                    @click="generatePlan(quotation.quotation)">
                    <i class="fas fa-money-bill-alt"></i>&nbsp;Plan de Pagos
                  </button>
                </div>
              </div>
            </div>

            <transition name="fade">
              <div v-if="expanded_quotations[quotation.id]" class="quotation-list__treatments">
                <customer-treatment-item v-for="(treatment, j) in quotation.treatments" :selectable="true"
                  :selected="isTreatmentSelected(treatment)" :total="treatment.quoted_price" :key="j" :clinics="clinics"
                  :treatment="treatment" :clinic_type="clinic.type" :show_done="true" @paid="paidTreatment"
                  @select="selectedTreatment" @done="doneTreatment"></customer-treatment-item>
              </div>
            </transition>

            <transition name="fade">
              <div v-if="has_pending_treatments && enable_payments_v2" class="d-flex justify-content-center">
                <button type="button" class="btn btn-primary btn-wabident-round mx-2" @click="payAllTreatments(false)">
                  Pagar con Saldo
                </button>
                <button type="button" class="btn btn-primary btn-wabident-round mx-2" @click="payAllTreatments(true)">
                  Pagar Directamente
                </button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <!-- PAYMENTS TAB -->
    <div v-if="tab == 'payments'" class="row invoices my-2">
      <div class="col">
        <button type="button" class="btn btn-primary btn-wabident-round float-right mb-2" @click="addPayment">
          <span v-if="enable_payments_v2">
            <i class="fas fa-minus"></i>
            &nbsp;Asignar Saldo
          </span>
          <span v-else> Crear Cobro </span>
        </button>

        <button v-if="enable_payments_v2" type="button" class="btn btn-primary btn-wabident-round float-right mb-2 mx-3"
          @click="addDeposit">
          <i class="fas fa-plus"></i>
          &nbsp;
          <span> Añadir Saldo </span>
        </button>

        <div class="d-flex align-items-center mb-4">
          <div class="mx-1">
            <select id="customer_payments_orderby" v-model="orderby_payments" style="max-width: 150px"
              class="custom-select size-s">
              <option value="desc">Recientes</option>
              <option value="asc">Antiguos</option>
            </select>
            <label for="customer_payments_orderby" class="wabident-info">Ordenar por ...</label>
          </div>

          <div v-if="enable_payments_v2" class="mx-1">
            <select id="customer_payments_entry" v-model="entry_payments" style="max-width: 150px"
              class="custom-select size-s">
              <option :value="null">Todos</option>
              <option value="deposit">Saldo</option>
              <option value="assignment">Asignación</option>
            </select>
            <label for="customer_payments_entry" class="wabident-info">Tipo</label>
          </div>

          <div class="mx-1">
            <select id="customer_payments_type" v-model="type_payments" style="max-width: 150px"
              class="custom-select size-s">
              <option :value="null">Todas</option>
              <option :value="value" v-for="(name, value) in payment_types" :key="value">
                {{ name }}
              </option>
            </select>
            <label for="customer_payments_type" class="wabident-info">Forma de pago</label>
          </div>

          <div v-if="can_invoice" class="mx-1">
            <select id="customer_payments_filter_payments" v-model="filter_payments" style="max-width: 150px"
              class="custom-select size-s">
              <option :value="null">Todos</option>
              <option value="invoiced">Facturados</option>
              <option value="not_invoiced">Sin facturar</option>
            </select>
            <label for="customer_payments_filter_payments" class="wabident-info">Facturación</label>
          </div>
        </div>

        <div class="invoice-list">
          <customer-payment v-for="p in filtered_payments" :customer="customer" :payment="p" :key="p.id"
            @click="editPayment"></customer-payment>
        </div>
      </div>
    </div>

    <!-- INVOICES TAB -->
    <div v-if="can_invoice && tab == 'invoices'" class="row invoices my-2">
      <div class="col">
        <button type="button" class="btn btn-primary btn-wabident-round float-right mx-2 mb-2" @click="addInvoice">
          <i class="fas fa-plus"></i>
          &nbsp; Crear Factura
        </button>

        <button v-if="enable_payments_v2" type="button" class="btn btn-primary btn-wabident-round float-right mx-2 mb-2"
          @click="addDownpaymentInvoice">
          <i class="fas fa-plus"></i>
          &nbsp; Crear Fact. Anticipo
        </button>

        <div class="d-flex d-flex-row align-items-center mb-4">
          <div class="mx-1">
            <select id="customer_invoices_orderby" v-model="orderby_invoices" style="max-width: 150px"
              class="custom-select size-s">
              <option value="desc">Recientes</option>
              <option value="asc">Antiguas</option>
            </select>
            <label for="customer_invoices_orderby" class="wabident-info">Ordenar por ...</label>
          </div>

          <div class="mx-1">
            <select id="customer_invoices_filter_invoices" v-model="filter_invoices" style="max-width: 150px"
              class="custom-select size-s">
              <option :value="null">Todas</option>
              <option value="paid">Pagadas</option>
              <option value="not_paid">Sin pagar</option>
              <option value="rectified">Rectificadas</option>
            </select>
            <label for="customer_invoices_filter_invoices" class="wabident-info">Estado</label>
          </div>
        </div>

        <div class="invoice-list">
          <customer-invoice v-for="i in filtered_invoices" :customer="customer" :invoice="i" :key="i.id"
            @edit="editInvoice"></customer-invoice>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["customer"],
  data() {
    return {
      tab: "pending",
      is_loading: false,
      selected_treatments: [],
      filter_invoices: null,
      filter_payments: null,
      entry_payments: null,
      type_payments: null,
      orderby_payments: "desc",
      orderby_invoices: "desc",
      expanded_quotations: {},
      data: {
        quotations: [],
        invoices: [],
        payments: [],
        available_treatments: [],
        pending_treatments: [],
        total_quoted: 0,
        total_pending: 0,
        total_all_quoted: 0,
        total_deposited: 0,
      },
      payment_types: {
        cash: "Efectivo",
        credit_card: "Tarjeta",
        direct_debit: "Financiación",
        mobile: "Bizum/Móvil",
        transfer: "Transferencia",
        tpv: "TPV",
        sepa_transfer: "Adeudo SEPA",
        other: "Otros",
      },
    };
  },
  computed: {
    enable_sepa_transfers() {
      return this.clinic && this.clinic.config.payments_enable_sepa_transfers;
    },
    hide_paid_treatments() {
      return this.clinic && this.clinic.config.customer_invoices_hide_treatment_paid;
    },
    balance_mismatch() {
      return false;
      return (
        this.enable_payments_v2 &&
        this.data.total_treatments_paid > this.data.total_deposited
      );
    },
    tooltip_title() {
      return this.enable_payments_v2
        ? "Saldo = Max(Depositado, Marcado Pagado) - Realizado"
        : "Saldo = Pagado - Realizado";
    },
    pending_quotations() {
      let ret = {};

      this.data.pending_treatments.forEach((treatment) => {
        // Filter out paid treatments - Should be marked as done in History/Plans
        if (this.hide_paid_treatments && treatment.is_paid) {
          return;
        }

        // Do not make double payments
        const id = treatment.quotation_id;
        const quotation = this.getQuotation(id);
        if (quotation) {
          const name =
            quotation.notes && quotation.notes != ""
              ? quotation.notes
              : quotation.code;

          let bucket = ret[id] || {
            id: id,
            treatments: [],
            name: name,
            created_at: moment(quotation.created_at).format('DD/MM/YYYY'),
            net_price: WabiDent.fmtMoney(quotation.net_price),
            quotation: quotation,
          };

          bucket.treatments.push(treatment);
          ret[id] = bucket;
        }
      });

      return Object.values(ret);
    },
    agenda_only() {
      return this.clinic && this.clinic.capabilities.agenda_only;
    },
    filtered_payments() {
      let ret = this.data.payments.filter((payment) => {
        if (this.type_payments !== null) {
          if (payment.type !== this.type_payments) return false;
        }

        switch (this.entry_payments) {
          case "assignment":
            if (payment.accounting_entry !== "assignment") return false;
            break;
          case "deposit":
            if (payment.accounting_entry !== "deposit") return false;
            break;
        }

        switch (this.filter_payments) {
          case "invoiced":
            if (payment.invoice_id === null) return false;
            break;
          case "not_invoiced":
            if (payment.invoice_id !== null) return false;
            break;
        }

        return true;
      });

      if (this.orderby_payments == "asc") {
        ret = ret.sort((a, b) => {
          return moment(a.created_at).diff(b.created_at, "seconds");
        });
      } else {
        ret = ret.sort((a, b) => {
          return moment(b.created_at).diff(a.created_at, "seconds");
        });
      }

      return ret;
    },
    filtered_invoices() {
      let ret = this.data.invoices.filter((invoice) => {
        switch (this.filter_invoices) {
          case "paid":
            return invoice.is_paid && !invoice.revocation_invoice_id;
          case "not_paid":
            return !invoice.is_paid && !invoice.revocation_invoice_id;
          case "rectified":
            return invoice.revocation_invoice_id != null;
          default:
            return true;
        }
      });

      if (this.orderby_invoices == "asc") {
        ret.sort((a, b) => {
          return moment(a.created_at).diff(b.created_at, "seconds");
        });
      }

      return ret;
    },
    is_dental() {
      if (!this.clinic) return true;
      return this.clinic.type == "dental";
    },
    has_pending_treatments() {
      if (this.is_loading) return false;
      if (!this.selected_treatments) return false;
      return this.selected_treatments.length > 0;
    },
    customer_payment_report_link() {
      if (!this.customer) return "";

      return `/customer/${this.customer.id}/payments_report`;
    },
    pretty_all_quoted() {
      return WabiDent.fmtMoney(this.data.total_all_quoted, 0);
    },
    pretty_quoted() {
      return WabiDent.fmtMoney(this.data.total_quoted, 0);
    },
    pretty_paid() {
      return WabiDent.fmtMoney(this.data.total_treatments_paid, 0);
    },
    pretty_deposited() {
      return WabiDent.fmtMoney(this.data.total_deposited, 0);
    },
    pretty_assigned() {
      return WabiDent.fmtMoney(this.data.total_assigned, 0);
    },
    pretty_done() {
      return WabiDent.fmtMoney(this.data.total_done, 0);
    },
    pretty_not_done() {
      return WabiDent.fmtMoney(
        this.data.total_quoted - this.data.total_done,
        0
      );
    },
    treatment_pending() {
      return this.data.total_done - this.data.total_treatments_paid;
    },
    pending() {
      let pending = this.data.total_paid - this.data.total_done;
      if (this.enable_payments_v2) {
        pending = this.data.total_deposited - this.data.total_assigned;
      }

      if (Math.abs(pending) < 0.01) {
        pending = 0;
      }
      return pending;
    },
    pretty_pending() {
      return WabiDent.fmtMoney(this.pending, 0);
    },
    show_treatment_pending() {
      return this.clinic && this.clinic.config && !this.clinic.config.customer_invoices_hide_treatment_pending;
    },
    pretty_treatment_pending() {
      return WabiDent.fmtMoney(this.treatment_pending, 0);
    },
    filtered_quotations() {
      return this.data.quotations;
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    can_invoice() {
      return this.clinic && this.clinic.config && !this.clinic.config.disable_invoices;
    },
    done_warning() {
      if (this.clinic && this.clinic.type == "dental") {
        return "¡El tratamiento viene hecho de otra clínica!";
      } else return "¡El tratamiento es una revisión!";
    },
    enable_payments_v2() {
      return this.clinic.config["enable_payments_v2"] || false;
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic", "is_core"]),
  },
  methods: {
    generatePlan(quotation) {
      this.$refs.genpayments.show(quotation);
    },
    toggleQuotation(id) {
      let val = Boolean(this.expanded_quotations[id]);
      this.$set(this.expanded_quotations, id, !val);
    },
    isTreatmentSelected(treatment) {
      return Boolean(
        this.selected_treatments.find((t) => {
          return t.id == treatment.id;
        })
      );
    },
    selectedTreatment(treatment, selected) {
      if (selected) {
        this.selected_treatments.push(treatment);
      } else {
        this.selected_treatments = this.selected_treatments.filter((item) => {
          return item.id != treatment.id;
        });
      }
    },
    userCan(capability) {
      if (!this.clinic) return false;
      return this.clinic.capabilities[capability] || false;
    },
    addQuotation() {
      if (this.data.available_treatments.length <= 0) {
        this.errorwindow.show(
          "Error",
          'No hay tratamientos sin presupuestar. Debe añadir al menos uno desde la pestaña "Odontograma"'
        );
        return;
      }
      this.$refs.showquotation.showNew([], this.data.available_treatments);
    },
    editQuotation(q) {
      this.$refs.showquotation.showEdit(q, this.data.available_treatments);
    },
    getQuotation(id) {
      return this.data.quotations.find((x) => x.id == id);
    },
    approveQuotation(q) {
      if (!q.is_approved) {
        this.errorwindow.show(
          "Confirmación",
          "Una vez aprobado, no podrá modificarlo si no lo desbloquea primero.",
          "Sí, Aprobar",
          "Cancelar",
          () => {
            this.doApproveQuotation(q);
          }
        );
      } else {
        this.errorwindow.show(
          "Confirmación",
          "¿Desbloquear para editar?",
          "Sí, desbloquear",
          "Cancelar",
          () => {
            this.doUnlockQuotation(q);
          }
        );
      }
    },
    addDeposit() {
      this.$refs.showpayment.showNewDeposit();
    },
    addPayment() {
      this.$refs.showpayment.showNewAssignment();
    },
    editPayment(payment) {
      this.$refs.showpayment.showEdit(payment);
    },
    addDownpaymentInvoice() {
      this.$refs.showinvoice.showNewDownpayment();
    },
    addInvoice() {
      this.$refs.showinvoice.showNew();
    },
    editInvoice(invoice) {
      this.$refs.showinvoice.showEdit(invoice);
    },
    onSubmit() {
      this.selected_treatments = [];
      this.loadData();
    },
    doApproveQuotation(quotation) {
      axios
        .post(
          `/customer/${this.customer.id}/quotation/${quotation.id}/approve`,
          {}
        )
        .then((response) => {
          this.msgwindow.success("Presupuesto aprobado");
        })
        .catch((err) => {
          console.log("[ERR] doApproveQuotation ", err);
          this.msgwindow.error("Error aprobando !");
        })
        .then(() => {
          this.onSubmit();
        });
    },
    doUnlockQuotation(quotation) {
      axios
        .post(
          `/customer/${this.customer.id}/quotation/${quotation.id}/unlock`,
          {}
        )
        .then((response) => {
          this.msgwindow.success("Presupuesto desbloqueado");
        })
        .catch((err) => {
          console.log("[ERR] doUnlockquotation ", err);
          this.msgwindow.error("Error aprobando !");
        })
        .then(() => {
          this.onSubmit();
        });
    },
    loadData() {
      let params = {
        clinic_id: this.clinic.id,
      };
      axios
        .get(`/customer/${this.customer.id}/invoices`, { params })
        .then((response) => {
          this.data = response.data;
        })
        .catch((err) => {
          this.msgwindow.error("Error leyendo facturas de cliente");
          console.log("[ERR] loadInvoiceData: ", err);
        });
    },
    nullOrEmpty(array) {
      return !array || array.length == 0;
    },
    getTreatmentTotal(treatment) {
      let quotation = this.filtered_quotations.find((q) => {
        return q.id == treatment.quotation_id;
      });

      if (!quotation) return 0;

      let line = quotation.quotationlines.find((l) => {
        // No product match -> fail
        if (l.product_id != treatment.product_id) return false;
        // Both empty -> ok
        if (this.nullOrEmpty(l.teeth) && this.nullOrEmpty(treatment.teeth))
          return true;
        // Any empty -> fail
        if (this.nullOrEmpty(l.teeth)) return false;
        if (this.nullOrEmpty(treatment.teeth)) return false;

        return (
          l.teeth.filter((x) => {
            return treatment.teeth.indexOf(x) !== -1;
          }).length > 0
        );
      });

      if (!line) return 0;

      return (
        Number(line.price) * (1 - Number(line.discount / 100)) -
        line.abs_discount
      );
    },
    markTreatmentAsPaid(treatment) {
      if (this.is_loading) return;
      this.is_loading = true;
      axios
        .post(`/customer/${this.customer.id}/treatment/${treatment.id}/paid`)
        .then((response) => {
          if (response.data.error) {
            this.msgwindow.error(response.data.error);
          } else {
            this.msgwindow.success("Tratamiento actualizado");
          }
        })
        .catch((error) => {
          console.log("[ERR] markTreatmentAsPaid ", error);
          this.msgwindow.error("Error actualizando tratamiento ");
        })
        .then(() => {
          this.is_loading = false;
        });
    },
    confirmPaidTreatment(treatment) {
      this.msgwindow.info("Buscando precio del tratamiento ...");
      axios
        .get(`/customer/${this.customer.id}/treatment/${treatment.id}/price`)
        .then((response) => {
          let price = response.data.price;
          if (price) {
            this.invoices = response.data.invoices;
            this.$refs.showpayment.showNewTreatment(
              treatment,
              price,
              response.data.invoices
            );
          } else {
            this.is_loading = false;
            this.markTreatmentAsPaid(treatment);
          }
        })
        .catch((error) => {
          console.log("[ERR] confirmPaidTreatment ", error);
          this.msgwindow.error("Error actualizando tratamiento ");
        })
        .then(() => {
          this.is_loading = false;
          this.loadData();
        });
    },
    confirmPaidTreatments(treatments, with_deposit) {
      let quotation_ids = treatments.map((t) => {
        return t.quotation_id;
      });

      let invoices = this.data.invoices.filter((i) => {
        return quotation_ids.includes(i.quotation_id);
      });

      this.$refs.showpaymentmult.showNewTreatments(
        treatments,
        invoices,
        with_deposit
      );
    },
    payAllTreatments(with_deposit = false) {
      if (this.is_loading) return;
      this.confirmPaidTreatments(this.selected_treatments, with_deposit);
    },
    paidTreatment(treatment) {
      if (this.is_loading) return;

      if (treatment.status == "done_prior") {
        this.msgwindow.warning(this.done_warning);
        return;
      }

      if (!treatment.quotation_id) {
        this.msgwindow.warning("El tratamiento no se ha presupuestado !");
        return;
      }

      this.is_loading = true;
      this.confirmPaidTreatment(treatment);
    },
    doneTreatment(treatment) {
      if (this.is_loading) return;

      if (treatment.status == "done_prior" && this.clinic.type == "dental") {
        this.msgwindow.warning(this.done_warning);
        return;
      }

      this.is_loading = true;

      axios
        .post(`/customer/${this.customer.id}/treatment/${treatment.id}/done`)
        .then((response) => {
          if (response.data.warning) {
            this.msgwindow.warning(response.data.warning);
          }

          if (response.data.error) {
            this.msgwindow.error(response.data.error);
          } else {
            this.msgwindow.success("Tratamiento actualizado");
          }
        })
        .catch((error) => {
          console.log("[ERR] doneTreatment ", error);
          this.msgwindow.error("Error actualizando tratamiento ");
        })
        .then(() => {
          this.is_loading = false;
          this.loadData();
        });
    },
    showMismatch() {
      let message =
        `<p>El paciente tiene tratamientos realizados por valor de <strong>${this.pretty_done}</strong> pero solo tiene depositados <strong>${this.pretty_deposited}</strong> en saldo.` +
        `<p>Revisa que todos los tratamientos marcados como pagados tengan un pago asignado en la pestaña <strong>Transacciones</strong> ` +
        `<p>Si se trata de un paciente importado de CliniWin, es posible que no se haya podido importar todos los pagos.<p><strong>¿Quieres poner un saldo inicial al paciente para reconciliar los dos saldos?</strong>`;

      this.errorwindow.show(
        "Advertencia",
        message,
        "Corregir",
        "Cancelar",
        () => {
          this.fixMismatch();
        }
      );
    },
    fixMismatch() {
      let options = {
        type: "other",
        created_at: this.customer.created_at,
        amount: this.data.total_done - this.data.total_deposited,
        notes: "SALDO INICIAL",
      };

      this.$refs.showpayment.showNew("deposit", options);
    },
  },
  mounted() {
    this.expanded_quotations = {};
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.quotation-list,
.invoice-list,
.treatment-list,
.customer-edit-invoices {
  margin-top: 0 15px;
}

.customer-edit-invoices {
  .quotation-list-empty {
    font-weight: bold;
    font-size: 20px;
    padding: 20px;
    text-align: center;
  }

  &__boxed {
    border-radius: 10px;
    background: var(--ui-gris-oscuro, #edeff2);
    padding: 20px;
  }

  &__balance {
    font-size: 14px;
    color: var(--theme-text-color);
    font-weight: bold;

    strong {
      font-size: 40px;
      display: block;
    }
  }

  &__balance-new {
    strong {
      font-size: 24px;
    }
  }

  &__summary-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13.2px;
    font-weight: 900;

    &+.customer-edit-invoices__summary-item {
      border-top: 1px white solid;
    }
  }

  &__tabs {
    margin: 20px 0px;
  }

  &__tab {
    text-align: center;
    color: var(--texto-gris, #a6aab4);
    background: var(--ui-gris-oscuro, #edeff2);
    transition: 0.3s;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 10px 0;
    cursor: pointer;

    &:hover,
    &.active {
      color: white;
      background-color: var(--theme-color);
    }
  }

  .quotation-list {
    &__title {
      cursor: pointer;
      font-size: 18px;
      font-weight: 500;
      padding: 20px 20px 20px 0px;
    }

    &__icon {
      transition: 0.3s;
      margin-right: 18px;
    }

    &__treatments {
      padding: 0 40px 10px 40px;
    }

    &__item {
      border-bottom: 3px solid var(--ui-gris-oscuro, #edeff2);
      padding-bottom: 19px;

      &.expanded {
        .quotation-list__icon {
          transform: rotate(-180deg);
        }
      }
    }
  }

  &__pending {
    background-color: #fafafa;
    padding: 27px 19px;

    .summary-header {
      font-size: 16px;
      line-height: 1.25;
      color: #3b414b;
    }

    .total-quoted {
      font-size: 14px;
      color: var(--theme-grey);
      font-weight: 500;
    }

    .total-pending {
      font-size: 32px;
      color: var(--theme-text-color);
      font-weight: 800;
      letter-spacing: 0.35px;

      sup {
        font-size: 12px;
      }
    }
  }
}
</style>
